<template>
  <div>
    <div style="overflow: hidden">
      <div class="wrapper_all wrapper_app_job flex-col">
        <div class="knowledge-box h100">
          <div class="head flex-row-space-between">
            知识点管理
            <div>
              <el-button :disabled="!isShowKnowledgeBotton" title="请选择章节节点"
                         class="mr10" @click="showBatchAddDialog">导入知识点
              </el-button>
              <el-popover
                  placement="bottom"
                  width="400"
                  v-model="isShowAddKnowledge"
                  @show="showAddKnowledge"
              >
                <el-input ref="addKnowledgeInputDom" @keyup.enter.native="addKnowledge"
                          v-model="newKnowledgeForm.name" placeholder="请输入"></el-input>
                <div style="text-align: right; margin-top: 10px">
                  <el-button size="mini" type="text" @click="isShowAddKnowledge = false;">取消</el-button>
                  <el-button type="primary" size="mini" @click="addKnowledge">确定</el-button>
                </div>
                <el-button slot="reference" :disabled="!isShowKnowledgeBotton" title="请选择章节节点">新建知识点</el-button>
              </el-popover>
            </div>
          </div>
          <div class="content-box flex-row">
            <div class="content-left h100">
              <div class="select-box flex-row-space-between">
                <span>学科</span>
                <el-cascader
                    v-model="chosedSubject"
                    :options="subjectList"
                    @change="getTextbooks"
                    placeholder="请选择学科"
                ></el-cascader>
              </div>
              <div class="pad10">
                <el-cascader
                    class="wp100"
                    v-model="chosedTextbook"
                    :options="textbookList"
                    @change="getChapters"
                    placeholder="请选择教材"
                ></el-cascader>
                <br/>
              </div>
              <div class="pad10">
                <el-tree :data="chapterList" :highlight-current="true"
                         @node-click=getKnowledges
                ></el-tree>
              </div>
            </div>
            <div class="content-right h100" :v-loading="isLoading">
              <div class="knowledge-list-box" v-if="chosedChapter.id">
                <div class="one wp100 flex-row-space-between" v-for="item in knowledgeList">
                  <div class="title">{{ item.name }}</div>
                  <div class="flex-row">
                    <el-button size="medium" plain @click="showRename(item)">重命名</el-button>
                    <el-button size="medium" plain @click="showMaterialListDialog(item)">查看资料</el-button>
                    <el-button class="mr10" size="medium" plain @click="showExampleListDialog(item)">查看例题</el-button>
                    <el-dropdown>
                      <el-button size="medium" plain>
                        更多<i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <a @click="cancelConnectKnowledge(item)">
                          <el-dropdown-item>取消导入关联</el-dropdown-item>
                        </a>
                        <a @click="removeKnowledge(item)">
                          <el-dropdown-item>删除</el-dropdown-item>
                        </a>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              <div v-else>
                <el-empty image="img/老师.330b5372.png" description="请选中章节节点"></el-empty>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- dialog -->
    <!--导入知识点-->
    <el-dialog
        title="关联知识点"
        :visible.sync="isShowBatchAddDialog"
        width="30%"
    >
      <div class="knowledges-section2-left">
        <el-cascader
            v-model="batchChosedTextbook"
            :options="textbookList"
            @change="getTextbookKnowledge"
            placeholder="请选择教材"
        ></el-cascader>
      </div>
      <div style="padding: 10px 0px">
        <el-tree ref="treeBatchKnowledgeDom"
                 :data="treeBatchKnowledge"
                 node-key="id"
                 show-checkbox
        ></el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowBatchAddDialog = false;">取 消</el-button>
        <el-button type="primary" @click="batchAddKnowledge">确定关联知识点</el-button>
      </span>
    </el-dialog>

    <!--重命名知识点-->
    <el-dialog
        title="重命名知识点" :visible.sync="isShowRename"
        width="30%" center
    >
      <el-form ref="form" label-width="80px">
        <el-form-item label="名称">
          <el-input type="textarea" :rows="3" ref="renameFormInputDom" v-model="renameForm.name"></el-input>

        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updateRename">确认</el-button>
          <el-button @click="isShowRename = false;">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--资料列表-->
    <el-dialog
        :title="'资料列表'"
        :visible.sync="isShowMaterialListDialog"
        width="60%"
        append-to-body
    >
      <MaterialList v-if="isShowMaterialListDialog" :prop-flag="materialListFlag"
                    :prop-knowledge="currentMaterialKnowledge"
                    @close="closeMaterialListDialog"
      ></MaterialList>
    </el-dialog>

    <!--例题列表-->
    <el-dialog
        :title="'例题列表'"
        :visible.sync="isShowExampleListDialog"
        width="60%"
        append-to-body
    >
      <ExampleList v-if="isShowExampleListDialog" :prop-flag="exampleListFlag"
                   :prop-knowledge="currentExampleKnowledge"
                   @close="closeExampleListDialog"
      ></ExampleList>
    </el-dialog>

    <!-- /dialog -->
  </div>
</template>

<script>
import MaterialList from './MaterialList';
import ExampleList from './ExampleList';

export default {
  name: 'knowledge',
  components: {MaterialList, ExampleList},
  data() {
    return {
      currentKnowledge: {},
      // 学科
      subjectList: [],
      chosedSubject: [],
      // 教材
      textbookList: [],
      chosedTextbook: [],
      // 章节
      chapterList: [],
      chosedChapter: {},
      isShowKnowledgeBotton: false,

      // 知识点相关操作
      isLoading: false,
      knowledgeList: [],
      // 导入知识点
      isShowBatchAddDialog: false,
      batchChosedTextbook: [],
      treeBatchKnowledge: [],
      // 新建知识点
      isShowAddKnowledge: false,
      newKnowledgeForm: {categoryId: null, name: ''},
      // 重命名
      isShowRename: false,
      currentRenameItem: null,
      renameForm: {},

      // 资料
      currentMaterialKnowledge: null,
      isShowMaterialListDialog: false,
      materialListFlag: false,

      // 例题
      currentExampleKnowledge: null,
      isShowExampleListDialog: false,
      exampleListFlag: false,

    };
  },
  methods: {
    init() {
      this.currentKnowledge = JSON.parse(sessionStorage.getItem('currentKnowledge'));
      if (!this.currentKnowledge) {
        this.currentKnowledge = {};
      } else {
        this.chosedSubject = this.currentKnowledge.chosedSubject;
        this.chosedTextbook = this.currentKnowledge.chosedTextbook;
      }
      this.getSubject();
    },
    // 获取学科
    getSubject() {
      let params = {
        invalid: 0,
      };
      this.axios.get(`/bank/basedata/v1.0/subjects`, {params: params}).then(res => {
        let data = res.data.data;
        let arr1 = [];
        let arr2 = [];
        let arr3 = [];
        data.forEach(function(value, index, array) {
          value = {...value, label: value.name, value: value.id};
          if (value.phase == '小学') {
            arr1.push(value);
          }
          if (value.phase == '初中') {
            arr2.push(value);
          }
          if (value.phase == '高中') {
            arr3.push(value);
          }
        });
        let list = [
          {value: '小学', label: '小学', children: arr1},
          {value: '初中', label: '初中', children: arr2},
          {value: '高中', label: '高中', children: arr3},
        ];
        this.subjectList = list;
        // 获取教材
        if (this.chosedSubject && this.chosedSubject.length) {
          this.getTextbooks(this.chosedSubject);
        }
      });
    },
    // 获取教材
    getTextbooks(chosedSubject) {
      this.isShowKnowledgeBotton = false;
      var subjectId = chosedSubject[1];
      this.textbookList = [];
      this.axios.get(`/bank/basedata/v1.0/subjects/${subjectId}/textbooks`).then((res) => {
        let data = res.data.data;
        data.forEach((item, index) => {
          item.label = item.name;
          item.value = item.id;
        });

        // 选中的教材不在教材列表中
        let index = data.findIndex(o => {
          return o.id == this.chosedTextbook[1];
        });
        if (index == -1) {
          this.chosedTextbook = [];
          this.chosedChapter = [];
          this.chapterList = [];
        }

        let data2 = this.getTrees(data);
        this.removeTextbookListEmptyChild(data2);
        this.textbookList = data2;
        // 获取章节
        if (this.chosedTextbook && this.chosedTextbook.length) {
          this.getChapters(this.chosedTextbook);
        }
      });
    },
    // 获取章节
    getChapters(chosedTextbook) {
      this.currentKnowledge = {chosedSubject: this.chosedSubject, chosedTextbook: this.chosedTextbook};
      sessionStorage.setItem('currentKnowledge', JSON.stringify(this.currentKnowledge));
      this.isShowKnowledgeBotton = false;
      var textbookId = chosedTextbook[1];
      this.chapterList = [];
      this.axios.get(`/bank/basedata/v1.0/textbooks/${textbookId}/chapters`).then((res) => {
        let data = res.data.data;
        data.forEach((item, index) => {
          item.label = item.name;
          item.value = item.id;
        });
        let data2 = this.getTrees(data);
        this.removeTextbookListEmptyChild(data2);
        this.chapterList = data2;
      });
    },

    // 获取知识点
    getKnowledges(chosedChapter) {
      console.log('chosedChapter', chosedChapter);
      if (chosedChapter.type == 2) {
        this.chosedChapter = chosedChapter;
        this.isShowKnowledgeBotton = true;
        this.reloadKnowledge();
      } else {
        this.chosedChapter = [];
        this.isShowKnowledgeBotton = false;
      }
    },
    reloadKnowledge() {
      this.isLoading = true;
      let params = {
        chapterId: this.chosedChapter.id,
      };
      this.axios.get(`/bank/basedata/v1.0/knowledge`, {params: params}).then(res => {
        this.isLoading = false;
        this.knowledgeList = res.data.data;
      });
    },

    // 知识点相关操作
    // 导入知识点
    showBatchAddDialog() {
      if (!this.chosedChapter.id) {
        this.$alert('请选中章节节点');
        return;
      }
      let currentBatchKnowledgeTextbook = sessionStorage.getItem('currentBatchKnowledgeTextbook');
      if (currentBatchKnowledgeTextbook) {
        this.batchChosedTextbook = JSON.parse(currentBatchKnowledgeTextbook).chosedTextbook;
      } else {
        this.batchChosedTextbook = [];
      }

      this.getTextbookKnowledge();
      this.isShowBatchAddDialog = true;
    },
    getTextbookKnowledge() {
      let currentBatchKnowledgeTextbook = {chosedTextbook: this.batchChosedTextbook};
      sessionStorage.setItem('currentBatchKnowledgeTextbook', JSON.stringify(currentBatchKnowledgeTextbook));
      this.axios.get(`/bank/basedata/v1.0/subjects/textbooks/${this.batchChosedTextbook[1]}/knowledge`).then(res => {
        let data = res.data.data;
        data.forEach((item, index) => {
          item.label = item.name;
        });
        let data2 = this.getTrees(data);
        this.removeTextbookListEmptyChild(data2);
        this.treeBatchKnowledge = JSON.parse(JSON.stringify(data2));
      });
    },
    batchAddKnowledge() {
      let knowledgeIds = [];
      let nodes = this.$refs.treeBatchKnowledgeDom.getCheckedNodes(true);
      nodes.forEach(node => {
        if (node.type == 4) {
          knowledgeIds.push(node.id);
        }
      });
      if (!knowledgeIds.length) {
        this.$alert('请选择知识点');
        return;
      }
      let params = {knowledgeIds: knowledgeIds};
      this.axios.post(`/bank/basedata/v1.0/textbooks/chapters/${this.chosedChapter.id}/knowledge`, params).then(res => {
        this.reloadKnowledge();
        this.isShowBatchAddDialog = false;
      });
    },
    // 新建知识点
    showAddKnowledge() {
      this.newKnowledgeForm.name = '';
      // 新建时，自动focus
      this.$nextTick(() => {
        this.$refs.addKnowledgeInputDom.focus();
      });
    },
    addKnowledge() {
      if (!this.chosedChapter.id) {
        this.$alert('请选中章节节点');
        return;
      }
      if (!this.chosedChapter.name) {
        this.$alert('请输入知识点名称');
        return;
      }
      this.newKnowledgeForm.chapterId = this.chosedChapter.id;
      this.axios.post(`/bank/basedata/v1.0/knowledge`, this.newKnowledgeForm).then(res => {
        this.newKnowledgeForm.name = '';
        this.isShowAddKnowledge = false;
        this.reloadKnowledge();
      });
    },
    // 重命名
    showRename(item) {
      this.currentRenameItem = item;
      this.renameForm = {...item};
      this.isShowRename = true;
      // 重命名，自动focus
      this.$nextTick(() => {
        this.$refs.renameFormInputDom.focus();
      });
      console.log('this.renameForm', this.renameForm);
    },
    updateRename() {
      if (!this.renameForm.name) {
        this.$alert('请输入知识点');
        return;
      }
      this.axios.put(`/bank/basedata/v1.0/knowledge/${this.currentRenameItem.id}`, this.renameForm).then((res) => {
        if (res.data.code == 200) {
          this.currentRenameItem.name = this.renameForm.name;
          this.isShowRename = false;
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          });
        }
      });
    },
    // 取消关联知识点
    cancelConnectKnowledge(item) {
      this.$confirm(`导入知识点关联所有习题、资料等将从本知识点移出,是否确认取消关联?`, `取消关联知识点`).then(() => {
        let params = {knowledgeIds: [item.id]};
        this.axios.delete(`/bank/basedata/v1.0/textbooks/chapters/${this.chosedChapter.id}/knowledge`, {data: params}).
            then(res => {
              if (200 == res.data.code) {
                let index = this.knowledgeList.findIndex(o => o.id == item.id);
                if (index > -1) {
                  this.knowledgeList.splice(index, 1);
                }
              } else {
                this.$message({
                  message: res.data.message,
                  type: 'error',
                });
              }
            });
      });
    },
    // 删除知识点
    removeKnowledge(item) {
      this.$confirm(`将清空知识点下所有习题、资料等,是否确认删除知识点?`, `删除知识点`).then(() => {
        this.axios.put(`/bank/basedata/v1.0/knowledge/${item.id}/disable`).then(res => {
          if (200 == res.data.code) {
            let index = this.knowledgeList.findIndex(o => o.id == item.id);
            if (index > -1) {
              this.knowledgeList.splice(index, 1);
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            });
          }
        });
      });
    },

    // 资料列表
    showMaterialListDialog(knowledge) {
      this.currentMaterialKnowledge = knowledge;
      this.isShowMaterialListDialog = true;
      this.materialListFlag = !this.materialListFlag;
    },
    closeMaterialListDialog() {
      this.isShowMaterialListDialog = false;
    },

    // 例题列表
    showExampleListDialog(knowledge) {
      this.currentExampleKnowledge = knowledge;
      this.isShowExampleListDialog = true;
      this.exampleListFlag = !this.exampleListFlag;
    },
    closeExampleListDialog() {
      this.isShowExampleListDialog = false;
    },

    getTrees: function(list, parentId = '') {
      let parentObj = {};
      list.forEach((item) => {
        parentObj[item.id] = item;
      });
      if (!parentId) {
        return list.filter((item) => !parentObj[item.parentId]).map(
            (item) => ((item.children = this.getTrees(list, item.id)), item),
        );
      } else {
        return list.filter((item) => item.parentId == parentId).map(
            (item) => ((item.children = this.getTrees(list, item.id)), item),
        );
      }
    },
    removeTextbookListEmptyChild(list) {
      if (list) {
        list.forEach((item) => {
          if (Array.isArray(item.children) && item.children.length == 0) {
            item.children = null;
          } else {
            this.removeTextbookListEmptyChild(item.children);
          }
        });
      }
    },
    goKnowledgeMaterial() {
      this.$router.push('knowledge_material');
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.knowledge-box {
  background: #fff;
}

.h100 {
  height: 100%;
}

.pad10 {
  padding: 10px;
}

.mr10 {
  margin-right: 10px;
}

.wp100 {
  width: 100%;
}

.pointer {
  cursor: pointer;
}

.el-button--primary.is-plain:focus, .el-button--primary.is-plain:hover {
  color: #409EFF;
  background: #ecf5ff;
  border-color: #b3d8ff;
}

.el-button--danger.is-plain:focus, .el-button--danger.is-plain:hover {
  color: #F56C6C;
  background: #fef0f0;
  border-color: #fbc4c4;
}

.knowledge-box .head {
  height: 60px;
  padding: 0px 20px;
  border-bottom: 1px solid rgba(187, 187, 187, 100);
  color: #403f3f;
  font-size: 18px;
}

.knowledge-box .head .head-right-wz {
  font-size: 16px;
  margin-right: 30px;
}

.knowledge-box .head .head-right-wz.blue {
  color: #51A5F7;
}

.content-box {
  height: calc(100vh - 250px);
}

.content-box .content-left {
  width: 25%;
  border-right: 1px solid rgba(187, 187, 187, 100);
  overflow-y: auto;
}

.content-box .content-left .select-box {
  font-size: 16px;
  padding: 20px 10px 20px 20px;
  border-bottom: 1px solid rgba(187, 187, 187, 100);
  height: 80px;
  box-sizing: border-box;
}

.content-box .content-right {
  width: 75%;
  overflow-y: auto;
}

.knowledge-operation-box {
  padding: 20px 20px;
  border-bottom: 1px solid rgba(187, 187, 187, 100);
  box-sizing: border-box;
  height: 80px;
  box-sizing: border-box;
}

.knowledge-list-box {
  overflow-y: auto;
}

.knowledge-list-box .one {
  padding: 10px 20px;
  border-bottom: 1px solid rgba(187, 187, 187, 100);
  box-sizing: border-box;
}

.knowledge-list-box .one .title {
  width: 420px;
  word-wrap: break-word;
  word-break: normal;
}
</style>
